import _objectWithoutProperties from "babel-runtime/helpers/objectWithoutProperties";
import React from 'react';
import styled from "styled-components";
import NavLink from "react-router-dom/NavLink";
import { withProps } from "recompose";

import { get, mixin } from "../../style/util";
import Button from "../../components/Button";

export var Page404 = styled.main.withConfig({
  componentId: "qqiy17-0"
})(["align-items:center;box-sizing:border-box;display:flex;flex-direction:column;flex:1;height:100%;justify-content:center;padding:25px;text-align:center;"]);

export var Text = styled.p.withConfig({
  componentId: "qqiy17-1"
})(["", ";color:", ";margin:0.5em auto;padding:0;text-align:center;a{color:", ";text-decoration:underline;}"], mixin("font.default", 13), get("color.successText"), get("color.successText"));

export var Heading = styled.h2.withConfig({
  componentId: "qqiy17-2"
})(["", ";margin:0;padding:0;color:", ";text-align:center;"], mixin("font.bold", 22, 1.5), get("color.successText"));

var ReplayButton = styled(withProps({ primary: true })(Button.withComponent(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      primary = _ref.primary,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "primary"]);

  return React.createElement(NavLink, props);
}))).withConfig({
  componentId: "qqiy17-3"
})([""]);
export { ReplayButton };
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/pages/Page404/style.js
// module id = 467
// module chunks = 0